var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"circle",staticClass:"circle",style:({
		'backgroundColor': _vm.backColor,
		'width': _vm.diameter,
		'height': _vm.height
	})})}
var staticRenderFns = []

export { render, staticRenderFns }